// @<COPYRIGHT>@
// ==================================================
// Copyright (c) 2020 Siemens
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@

/**
 * This module provides workspace data cache.
 *
 * @module js/swf3dWorkspaceDataset
 */

// Workspace toolkit data cache.
var swf3dWorkspaceDataset = {
    previewCache: {},

    filterVMList: null
};

export default swf3dWorkspaceDataset;
